export default class AccordionTitleNodeView {
  constructor(node, view, getPos) {
    this.node = node;
    this.view = view;
    this.getPos = getPos;

    this.dom = document.createElement('div');

    if (node.attrs.active === true) {
      this.dom.className = 'title active';
    } else {
      this.dom.className = 'title';
    }

    const dropdownIcon = document.createElement('i');
    dropdownIcon.className = 'dropdown icon expand';
    dropdownIcon.contentEditable = 'false';
    dropdownIcon.addEventListener('click', e => this.handleClick(e))

    this.dom.appendChild(dropdownIcon);

    this.contentDOM = document.createElement('div');
    this.dom.appendChild(this.contentDOM)
  }

  handleClick(e) {
    e.preventDefault();
    const iconPos = this.view.posAtDOM(e.target);
    if (!iconPos) {
      return;
    }
    const titleNode = this.view.state.doc.resolve(iconPos).parent;
    const pos = this.getPos();
    this.view.dispatch(this.view.state.tr.setNodeMarkup(pos, undefined, {
      active: !this.node.attrs.active
    }));
    this.view.dispatch(this.view.state.tr.setNodeMarkup(pos + titleNode.nodeSize, undefined, {
      active: !this.node.attrs.active
    }));
  }

  destroy() {
    this.dom.remove();
    this.contentDOM.remove();
    delete this.dom;
    delete this.contentDOM;
  }
}